export default "__VITE_ASSET__332646b2__"